const AMEX_PREFIX_REGEX = /^3[47]/;

export const CARD_NUMBER_SPECS = {
  amex: {
    length: 15,
    blockSizes: [4, 6, 5]
  },
  default: {
    length: 16,
    blockSizes: [4, 4, 4, 4]
  }
};

export function detectCardBrand (digitsOnlyValue) {
  return AMEX_PREFIX_REGEX.test(digitsOnlyValue || "") ? "amex" : "default";
}

export function cardNumberSpecFor (value) {
  const digitsOnly = (value || "").replace(/\D/g, "");
  return CARD_NUMBER_SPECS[detectCardBrand(digitsOnly)];
}

export function formattedLengthFor (spec) {
  // digits + one separator space between each block
  return spec.length + spec.blockSizes.length - 1;
}

export function spacePositionsFor (spec) {
  // 1-indexed position of each separator space in the formatted string
  const positions = [];
  let cumulativeDigits = 0;

  spec.blockSizes.slice(0, -1).forEach((blockSize, index) => {
    cumulativeDigits += blockSize;
    positions.push(cumulativeDigits + index + 1);
  });

  return positions;
}
